import { CIMSSingleColumn } from 'components/CIMSTable/CIMSColumn/types'
import { ConcreteTestSet } from '../../ConcreteTestSetTrackerContext/types'

/**
 * Creates a case-insensitive partial-match search filter for values nested in a
 * {@link ConcreteTestSet}. Missing values are ignored so incomplete break data
 * does not prevent the remaining associated values from being searched.
 *
 * @param callback Collects the searchable values for a test set.
 */
export function breakDataSearchFilter(
  callback: (record: ConcreteTestSet) => (string | null | undefined)[]
): CIMSSingleColumn<ConcreteTestSet>['filter'] {
  return {
    type: 'search',
    with: 'callback',
    onFilter: (value, record) => {
      const search = value.toString().toLowerCase()
      return callback(record).some((item) =>
        item?.toLowerCase().includes(search)
      )
    },
  }
}
